package team.platforma.dictionary_data.repository

import kotlinx.coroutines.flow.Flow
import team.platforma.dictionary_data.database.ai_chapter.AiChapterTable
import team.platforma.dictionarydata.table.AiChapter

class AiChapterRepositoryImpl(
    private val aiChapterTable: AiChapterTable
):AiChapterRepository {
//    override suspend fun load(player: Player) {
//        playerTable.addChapter(player)
//    }


    private val mokList = listOf(
        AiChapter(
          -1,
            "Все"
        ),
        AiChapter(
            1,
            "Текст"
        ),
        AiChapter(
            2,
            "Картинки"
        ),
        AiChapter(
            3,
            "Видео"
        ),
        AiChapter(
            4,
            "Аудио"
        ),
    )

    override suspend fun load() {
        aiChapterTable.addChapterList(mokList)
    }

    override fun getAllPlayers(): Flow<List<AiChapter>> {
       return aiChapterTable.observeAllAiChapter()
    }

}